export default {
    methods: {
        showError(error, time = 3000) {
            this.showMessage(error, 'danger', time);
        },

        showMessage(message, color = 'success', time = 3000) {
            if (typeof message === 'string') {
                this.text = message
            }

            this.$buefy.toast.open({
                duration: time,
                message: message,
                position: 'is-top',
                type: 'is-'+color,
                queue: true
            })
        }
    }
};
